import { useEnterListener } from '@cashew/hooks';
import Input from '@cashew/input';
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import type { MerchantData } from '../MerchantOnboarding/util';
import './index.scss';
import SelectComponent from '../../components/SelectComponent';

const { api } = require('@cashew/utils');

const numericInput = /^[0-9]+$/;

export const getOrdersApi = (
  resetPageNumber = true,
  {
    setLoading,
    setRecords,
    setList,
    pageSize,
    pageNumber,
    dispatch,
    setPageNumber,
    type,
    records,
    startDate,
    endDate,
    tabIndex,
    status,
    setStatus,
    setParams,
    token,
    searchId,
    searchBy,
    t,
  }: any
) => {
  setLoading(true);

  if (resetPageNumber && pageNumber !== 0) {
    setPageNumber(0);
    return;
  }

  const params: any = {
    page: pageNumber,
    size: pageSize,
    startDate,
    endDate,
    status,
    settlementType: 'FINANCE_PARTNER',
  };

  if (searchId && searchBy) {
    params[searchBy] = searchId.trim();
  }

  setParams(params);
  api
    .get({
      endpoint: 'settlements',
      params,
      headers: {
        Authorization: token,
      },
    })
    .then((resp: any) => {
      const listSettlements = resp.data.map((item: any) => ({
        ...item,
        id: item.settlementId,
      }));
      const updatedListSettlements = listSettlements.map((item: any) => ({
        ...item,
        balance: -item.balance,
      }));
      setList(updatedListSettlements);
      setRecords(resp.totalCount);
    })
    .catch(() =>
      dispatch({
        type: 'OPEN_TOASTER',
        payload: {
          toasterTitle: t('dispatches.error.fetchingList.title'),
          toasterMessage: t('dispatches.error.fetchingList.message'),
          toasterType: 'error',
          toasterVisible: true,
          toasterDismiss: null,
        },
      })
    )
    .finally(() => {
      setLoading(false);
    });
};

export default ({
  setLoading,
  setRecords,
  setList,
  pageSize,
  pageNumber,
  dispatch,
  setPageNumber,
  type,
  records,
  startDate,
  endDate,
  tabIndex,
  status,
  setStatus,
  setParams,
}: any) => {
  const { t } = useTranslation();
  const { token } = useSelector((state: any) => state.user);
  const [searchId, setSearchId] = useState('');
  const [searchBy, setSearchBy] = useState<string>('financePartnerName');
  const [enterBtn, setEnterBtn] = useState(false);

  const searchByData = [
    {
      key: 'financePartnerName',
      value: 'Parner name',
    },
    {
      key: 'settlementId',
      value: 'Settlement ID',
    },
  ];

  useEffect(() => {
    if (tabIndex === 0) {
      setStatus('PENDING,PROCESSED');
    }
    if (tabIndex === 1) {
      setStatus('PENDING');
    }
    if (tabIndex === 2) {
      setStatus('PROCESSED');
    }
  }, [tabIndex]);

  const getOrdersApiLocal = (resetPageNumber = true) =>
    getOrdersApi(resetPageNumber, {
      setLoading,
      setRecords,
      setList,
      pageSize,
      pageNumber,
      dispatch,
      setPageNumber,
      type,
      records,
      startDate,
      endDate,
      tabIndex,
      status,
      setStatus,
      setParams,
      token,
      searchId,
      searchBy,
      t,
    });

  useEffect(() => {
    setSearchId('');
  }, [searchBy]);

  useEffect(() => {
    getOrdersApiLocal(false);
  }, [pageNumber, pageSize]);

  useEnterListener(() => setEnterBtn((prev) => !prev));

  useEffect(() => {
    getOrdersApiLocal();
  }, [startDate, endDate, status, enterBtn]);

  if (type !== 'cashew') return null;

  const handleSelectChange = (selectedKey: string) => {
    setSearchId('');
    setSearchBy(selectedKey);
  };

  return (
    <>
      <div className="filter-input">
        <SelectComponent
          label="Search by"
          data={searchByData}
          selected={searchBy}
          onSelect={handleSelectChange}
        />
      </div>
      <div className="filter-input">
        <Input
          name="orderId"
          value={searchId}
          type="text"
          maxLength={searchBy === 'orderId' ? 14 : 100}
          onChange={(e: any) => {
            const searchValue = e.target.value;
            if (searchBy === 'settlementId') {
              if (searchValue.match(numericInput) || searchValue === '') {
                setSearchId(searchValue);
              }
            } else {
              setSearchId(searchValue);
            }
          }}
        />
      </div>
      <div className="filter-input">
        <button
          type="button"
          className="btn blue"
          onClick={() => {
            getOrdersApiLocal();
          }}
        >
          Search
        </button>
      </div>
    </>
  );
};
